(function () {
  if (window.newentorComparisonAccordionDelegated) return;
  window.newentorComparisonAccordionDelegated = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-newentor-accordion] .newentor-comparison__accordion-summary');
    if (!trigger) return;

    var root = trigger.closest('[data-newentor-accordion]');
    if (!root) return;

    var open = !root.classList.contains('is-open');
    root.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
